import React, { useState } from 'react';
import PT from 'prop-types';
import { connect } from 'react-redux';
import { setCookie, deleteCookie } from 'stash/utils/cookies';
import {
	ChoiceGroup,
	Text,
	ChoicePadRadio,
	Box,
	PrimaryButton,
	TertiaryButton,
} from '@stashinvest/ui';
import { setGlobalTheme } from 'stash/actions';
import { THEMES, DEFAULT_THEME, DEV_THEME_PICKER_COOKIE } from 'stash/constants';

export const updateThemeCookie = (theme) => {
	setCookie(DEV_THEME_PICKER_COOKIE, theme);
};

export const deleteThemeCookie = () => {
	deleteCookie(DEV_THEME_PICKER_COOKIE);
};

const activeThemes = Object.values(THEMES).filter((theme) => theme.active);

export const mapStateToProps = (state) => {
	const { theme } = state.application.signUp;

	return {
		activeTheme: theme.name,
	};
};

export const mapDispatchToProps = {
	setGlobalTheme,
};

export const ThemePicker = (props) => {
	const { activeTheme, setGlobalTheme, onClickPrimaryButton, onClickSecondaryButton } =
		props;
	const [checkedTheme, setCheckedTheme] = useState(activeTheme);

	return (
		<Box>
			<Box overflowY="auto" overflowX="hidden">
				<ChoiceGroup
					cols={2}
					legend={`Select the theme to activate (${activeThemes.length})`}
				>
					{activeThemes.map((theme) => (
						<ChoicePadRadio
							onClick={() => {
								setCheckedTheme(theme.name);
							}}
							checked={theme.name === checkedTheme}
							key={theme.name}
							name="web-reg-theme"
							value={theme.name}
							label={
								<Text.Caption>
									<strong>{theme.name}</strong>
								</Text.Caption>
							}
						/>
					))}
				</ChoiceGroup>
				<Box mt="m" mx="auto" maxWidth="18rem">
					<PrimaryButton
						onClick={() => {
							updateThemeCookie(checkedTheme);
							setGlobalTheme(checkedTheme);
							onClickPrimaryButton();
						}}
					>
						Activate
					</PrimaryButton>
					<TertiaryButton
						onClick={() => {
							setGlobalTheme(DEFAULT_THEME);
							deleteThemeCookie();
							onClickSecondaryButton();
						}}
					>
						Turn off
					</TertiaryButton>
				</Box>
			</Box>
		</Box>
	);
};

ThemePicker.defaultProps = {
	onClickPrimaryButton: () => {},
	onClickSecondaryButton: () => {},
};

ThemePicker.propTypes = {
	activeTheme: PT.string,
	setGlobalTheme: PT.func,
	onClickPrimaryButton: PT.func,
	onClickSecondaryButton: PT.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemePicker);
